import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #ffffff;
  padding: 1rem;
  width: 100%;
  border-radius: 6px;
`
